import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs';
import { AccountEndpoint } from '../../../services/account-endpoint.service';
import { AccountService } from '../../../services/account.service';
import { DBkeys } from '../../../services/db-Keys';
import { GasTwoService } from '../../../services/gatwo.service';
import { LocalStoreManager } from '../../../services/local-store-manager.service';
var _ = require('lodash');
require('chart.js');

@Component({
    selector: 'gastwo-statistics',
    template: require('./gastwo-statistics.component.html'),
    styles: [require('./gastwo-statistics.component.css')],
})
export class GasTwoStatisticsComponent implements OnInit, OnDestroy {

    private subscribers: Subscription[] = [];

    @Input('monthsCount') monthsCount: number;
    suggestedMin: number = 30;
    suggestedMax: number = 50;
    Min: number = 30;
    Max: number = 50;
    gastwoStatistics: any;
    gastwoCount: number;
    chartData: Array<any> = [];
    chartLabels: Array<any> = [];
    chartOptions: any;
    chartColors: Array<any> = [
        {
            // Light red
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            pointBackgroundColor: 'rgba(255, 99, 132, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(255, 99, 132, 0.8)'
        },
        {
            // Bright blue
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            pointBackgroundColor: 'rgba(54, 162, 235, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(54, 162, 235, 0.8)'
        },
        {
            // Light orange
            backgroundColor: 'rgba(255, 206, 86, 0.2)',
            borderColor: 'rgba(255, 206, 86, 1)',
            pointBackgroundColor: 'rgba(255, 206, 86, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(255, 206, 86, 1)'
        },
        {
            // Moderate cyan
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            borderColor: 'rgba(75, 192, 192, 1)',
            pointBackgroundColor: 'rgba(75, 192, 192, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(75, 192, 192,0.8)'
        }
    ];
    chartLegend: boolean = true;
    chartType: string = 'line';
    loading: boolean = false;
    GetResult: any;
    gastwoStatisticsttf: any;
    gasttfdataStatisticsData: any;
    applicationVersionName: any;

    constructor(private gastwoService: GasTwoService, private ngxLogger: NGXLogger, private storageManager: LocalStoreManager,
        private accountService: AccountService, private accountEndpoint: AccountEndpoint) { }

    ngOnInit() {
        this.loading = true;
        this.applicationVersionName = this.accountService.applicationVersionName;
        const getStatiSubscriber = this.gastwoService.getStatistics(this.monthsCount).subscribe((res: any) => {
            if (res.Item2) {
                this.refreshChart(res.Item1, res.Item3);
            } else {
                let OChartData, OChartLabels, OMin, OMax;
                if (res.Item3) {
                    OChartData = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASTWOTRIALCHARTDATA);
                    OChartLabels = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASTWOTRIALCHARTLABELS);
                    OMin = this.storageManager.getMin(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASTWOTRIALMIN);
                    OMax = this.storageManager.getMax(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASTWOTRIALMAX);
                } else {
                    OChartData = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASTWOCHARTDATA);
                    OChartLabels = this.storageManager.getchartData(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASTWOCHARTLABELS);
                    OMin = this.storageManager.getMin(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASTWOMIN);
                    OMax = this.storageManager.getMax(this.storageManager.getApplicationVersion(DBkeys.APPLICATIONVERSION) + "_" + DBkeys.GASTWOMAX);
                }
                if (OChartData != null && OChartLabels != null && OMin != null && OMax != null) {
                    this.refreshMemoryChart(OChartData, OChartLabels, OMin, OMax);
                } else if (OChartData == null || OChartLabels == null || OMin == null || OMax == null) {
                    this.gastwoService.getCacheStatistics(this.monthsCount).subscribe((res: any) => {
                        this.refreshChart(res.Item1, res.Item2);
                    });
                }
            }

        }, error => {
            this.loading = false;
            this.ngxLogger.error(error.message);
            throw error;
        });

        this.subscribers.push(getStatiSubscriber);
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    refreshChart(res, trial) {

        this.GetResult = res;

        this.gasttfdataStatisticsData = this.GetResult.gastwo.concat(this.GetResult.gasthree);

        this.gastwoStatisticsttf = _(this.gasttfdataStatisticsData).groupBy(x => x.StripName)
            .map((value, key) => ({ StripName: key, Data: value }))
            .value();

        this.GetResult.gasthree.forEach((obj) => {
            let existNotification = this.GetResult.gastwo.find(({ Datum }) => obj.Datum === Datum);
            if (!existNotification) {
                const newObj = { ...obj };
                newObj.SettlementPrice = 0;
                newObj.StripName = 'Gas TTF 101';
                this.GetResult.gastwo.push({ ...newObj });
            }
        });

        this.GetResult.gastwo.forEach((obj) => {
            let existNotification = this.GetResult.gasthree.find(({ Datum }) => obj.Datum === Datum);
            if (!existNotification) {
                const newObj = { ...obj };
                newObj.SettlementPrice = 0;
                newObj.StripName = 'Gas TTF 103';
                this.GetResult.gasthree.push({ ...newObj });
            }
        });

        let gasttf = this.GetResult.gastwo.concat(this.GetResult.gasthree);

        let temp = _(gasttf)
            .map((value, key) => ({ Data: value.SettlementPrice }))
            .value();

        let minFilter = temp.filter(gc => gc.Data != null);

        this.Max = Math.max.apply(Math, temp.map(function (o) { return o.Data; }));

        // this.suggestedMin = Math.floor(_.minBy(res, 'SettlementPrice').SettlementPrice) - 5;

        this.gastwoStatistics = _(gasttf).groupBy(x => x.StripName)
            .map((value, key) => ({ StripName: key, Data: value }))
            .value();

        this.Min = Math.min.apply(Math, minFilter.map(function (o) { return o.Data; }));


        // creates an array of the `value` property: [100, 22, 12]
        let numbers = this.gastwoStatisticsttf.map(i => i.Data.length);
        // gets the sum of the array of numbers: 134
        this.gastwoCount = numbers.reduce((a, b) => a + b, 0);

        this.loading = false;

        if (this.gastwoStatistics != null && this.gastwoStatistics !== undefined && this.gastwoStatistics.length > 0) {
            let _chartData: Array<any> = [{ data: new Array(this.gastwoStatistics.length) }];
            let _chartLabels: Array<any> = new Array(this.gastwoStatistics[0].Data.length);
            if (this.gastwoStatistics[1] != undefined) {
                _chartLabels = _.map(this.gastwoStatistics[0].Data.concat(this.gastwoStatistics[1].Data), 'Datum');
            }
            else {
                _chartLabels = _.map(this.gastwoStatistics[0].Data, 'Datum');
            }
            var unique = _chartLabels.filter(function (elem, index, self) {
                return index === self.indexOf(elem);
            })

            unique.sort((itemA, itemB) => {
                let mthAstr = itemA.slice(0, 3) + " 01 " + itemA.slice(3, 5);
                let mthA = new Date(mthAstr);
                let mthBstr = itemB.slice(0, 3) + " 01 " + itemB.slice(3, 5);
                let mthB = new Date(mthBstr);
                if (mthA < mthB)
                    return -1;
                if (mthA > mthB)
                    return 1;
                return 0;
            });

            this.gastwoStatistics[0].Data = _.orderBy(this.gastwoStatistics[0].Data, [(user) => (unique.indexOf(user.Datum))], ["asc", "asc"]);
            this.gastwoStatistics[1].Data = _.orderBy(this.gastwoStatistics[1].Data, [(user) => (unique.indexOf(user.Datum))], ["asc", "asc"]);

            for (let i = 0; i < this.gastwoStatistics.length; i++) {
                _chartData[i] = { data: new Array(this.gastwoStatistics[i].Data.length), label: this.gastwoStatistics[i].StripName };
                for (let j = 0; j < this.gastwoStatistics[i].Data.length; j++) {
                    _chartData[i].data[j] = this.gastwoStatistics[i].Data[j].SettlementPrice;
                }
            }
            this.chartData = _chartData;
            this.chartLabels = unique;
            this.chartOptions = {
                responsive: true,
                scales: {
                    yAxes: [{
                        ticks: {
                            // beginAtZero: true,
                            suggestedMin: this.suggestedMin,
                            suggestedMax: this.suggestedMax,
                            min: this.Min,
                            max: this.Max
                        }
                    }]
                },
                elements: {
                    line: {
                        fill: false
                    },
                    point: {
                        radius: 0
                    }
                }
            };

            if (this.applicationVersionName == null || this.applicationVersionName == undefined) {
                this.accountEndpoint.getApplicationVersionName().subscribe(res => {
                    this.applicationVersionName = res;
                    this.GetdataLocalSt(trial, _chartData, unique);
                });
            } else {
                this.storageManager.setApplicationVersion(this.applicationVersionName, DBkeys.APPLICATIONVERSION);
                this.GetdataLocalSt(trial, _chartData, unique);
            }
        }
    }

    GetdataLocalSt(trial, _chartData, unique) {
        if (trial) {
            this.storageManager.setchartData(_chartData, this.applicationVersionName + "_" + DBkeys.GASTWOTRIALCHARTDATA);
            this.storageManager.setchartLabels(unique, this.applicationVersionName + "_" + DBkeys.GASTWOTRIALCHARTLABELS);
            this.storageManager.setMax(this.Max, this.applicationVersionName + "_" + DBkeys.GASTWOTRIALMAX);
            this.storageManager.setMin(this.Min, this.applicationVersionName + "_" + DBkeys.GASTWOTRIALMIN);

        } else {
            this.storageManager.setchartData(_chartData, this.applicationVersionName + "_" + DBkeys.GASTWOCHARTDATA);
            this.storageManager.setchartLabels(unique, this.applicationVersionName + "_" + DBkeys.GASTWOCHARTLABELS);
            this.storageManager.setMax(this.Max, this.applicationVersionName + "_" + DBkeys.GASTWOMAX);
            this.storageManager.setMin(this.Min, this.applicationVersionName + "_" + DBkeys.GASTWOMIN);
        }
    }

    refreshMemoryChart(OChartData, OChartLabels, OMin, OMax) {
        this.loading = false;
        this.gastwoStatistics = OChartData;
        this.chartData = OChartData;
        this.chartLabels = OChartLabels;
        this.Min = OMin;
        this.Max = OMax;
        this.chartOptions = {
            responsive: true,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        suggestedMin: this.suggestedMin,
                        suggestedMax: this.suggestedMax,
                        min: this.Min,
                        max: this.Max
                    }
                }]
            },
            elements: {
                line: {
                    fill: false
                },
                point: {
                    radius: 0
                }
            }
        };
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/gas-two/gastwo-statistics/gastwo-statistics.component.ts